// extracted by mini-css-extract-plugin
module.exports = {"alpInfoHeader":"AlpInfoCard_alpInfoHeader__2_6Xi","alpInfoRow":"AlpInfoCard_alpInfoRow__2n5wE","alpInfoRowText":"AlpInfoCard_alpInfoRowText__1TYil"};